module.exports = __webpack_public_path__ + "static/flags/UG-1944fe1d94a49c9f5eb546a746abcbfb.gif";